"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledGoogleYellow = exports.StyledGoogleRed = exports.StyledGoogleGreen = exports.StyledGoogleBlue = exports.GoogleSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var StyledGoogleYellow = /*#__PURE__*/_styledComponents.default.path.withConfig({
  displayName: "StyledGoogleYellow",
  componentId: "c11n-8-109-1__sc-1hbb768-0"
})(["fill:#fbbc05;"]);
exports.StyledGoogleYellow = StyledGoogleYellow;
var StyledGoogleRed = /*#__PURE__*/_styledComponents.default.path.withConfig({
  displayName: "StyledGoogleRed",
  componentId: "c11n-8-109-1__sc-1hbb768-1"
})(["fill:#ea4335;"]);
exports.StyledGoogleRed = StyledGoogleRed;
var StyledGoogleGreen = /*#__PURE__*/_styledComponents.default.path.withConfig({
  displayName: "StyledGoogleGreen",
  componentId: "c11n-8-109-1__sc-1hbb768-2"
})(["fill:#34a853;"]);
exports.StyledGoogleGreen = StyledGoogleGreen;
var StyledGoogleBlue = /*#__PURE__*/_styledComponents.default.path.withConfig({
  displayName: "StyledGoogleBlue",
  componentId: "c11n-8-109-1__sc-1hbb768-3"
})(["fill:#4285f4;"]);
exports.StyledGoogleBlue = StyledGoogleBlue;
var GoogleSVG = function GoogleSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 48 48"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none"
  }, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M45 20H24v9h12c-1 5-6 8-12 8a13 13 0 1 1 8-23l7-6A22 22 0 0 0 2 24c0 12 10 22 22 22 11 0 21-8 21-22v-4z"
  })), /*#__PURE__*/_react.default.createElement(StyledGoogleYellow, {
    clipPath: "url(#a)",
    d: "M0 37V11l17 13z"
  }), /*#__PURE__*/_react.default.createElement(StyledGoogleRed, {
    clipPath: "url(#a)",
    d: "M0 11l17 13 7-6 24-4V0H0z"
  }), /*#__PURE__*/_react.default.createElement(StyledGoogleGreen, {
    clipPath: "url(#a)",
    d: "M0 37l30-23 8 1L48 0v48H0z"
  }), /*#__PURE__*/_react.default.createElement(StyledGoogleBlue, {
    clipPath: "url(#a)",
    d: "M48 48L17 24l-4-3 35-10z"
  })));
};
exports.GoogleSVG = GoogleSVG;
GoogleSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(GoogleSVG);
exports.default = _default;